<template>
    <div class="slider-item slider-item--zoom">
        <h2 ref="title" class="slider-item__title" v-html="title" />
        <div ref="iconList" class="slider-item__icon-list-wrapper">
            <ul class="slider-item__icon-list">
                <li v-for="item in listLine1" :key="item.label" class="slider-item__icon-list-item">
                    <img
                        :src="`/ressources/logged/img/illustrations/recap2024/slsy-${item.icon}.svg`"
                        :alt="item.label"
                    />
                    <span class="slider-item__icon-list-item-number">{{ item.number }}</span>
                    <span class="slider-item__icon-list-item-label">{{ item.label }}</span>
                </li>
            </ul>
            <ul class="slider-item__icon-list">
                <li v-for="item in listLine2" :key="item.label" class="slider-item__icon-list-item">
                    <img
                        :src="`/ressources/logged/img/illustrations/recap2024/slsy-${item.icon}.svg`"
                        :alt="item.label"
                    />
                    <span class="slider-item__icon-list-item-number">{{ item.number }}</span>
                    <span class="slider-item__icon-list-item-label">{{ item.label }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import anime from 'animejs';

export default {
    name: 'ZoomSlide',
    props: {
        title: {
            type: String,
            required: true,
        },
        listLine1: {
            type: Array,
            required: true,
        },
        listLine2: {
            type: Array,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                const animatedTimeline = anime.timeline({
                    delay: 300,
                });

                animatedTimeline
                    .add({
                        targets: this.$refs.title,
                        opacity: [0, 1],
                    })
                    .add({
                        targets: this.$refs.iconList.querySelectorAll(
                            '.slider-item__icon-list-item',
                        ),
                        scale: [0, 1],
                        opacity: [0, 1],
                        delay: anime.stagger(1000),
                    });
            } else {
                this.$refs.title.removeAttribute('style');
                const items = this.$refs.iconList.querySelectorAll('.slider-item__icon-list-item');
                for (const item of items) {
                    item.removeAttribute('style');
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    &.slider-item--zoom {
        align-items: flex-start;
        justify-content: flex-start;
    }

    gap: 40px;

    &__title {
        color: #c8d2fe;
        font-family: Patron, sans-serif;
        font-size: 48px;
        font-weight: 400;
        letter-spacing: -1px;
        line-height: 52px;
        margin: 0;
    }

    &__icon-list {
        &-wrapper {
            display: flex;
            flex: 1;
            flex-direction: column;
            gap: 32px;
            justify-content: center;
            width: 100%;
        }

        display: flex;
        gap: 20px;
        justify-content: center;
        list-style: none;
        margin: 0;
        padding: 0;

        &-item {
            align-items: center;
            display: flex;
            flex-direction: column;
            flex: 1;
            opacity: 0;
            text-align: center;

            &-number {
                color: var(--colors-sellsy-brand-primary-0);
                display: block;
                font-family: Patron, sans-serif;
                font-size: 24px;
                font-weight: 500;
                line-height: 26px;
                margin: var(--spacing-3) 0 0;
            }

            &-label {
                color: var(--colors-sellsy-brand-primary-10);
                font-family: Patron, sans-serif;
                font-size: 17px;
                font-weight: 400;
                line-height: 18px;
            }
        }
    }
}
</style>
